import { useEffect } from 'react';

/** Close a popover when the user clicks outside `containerRef`. */
export default function useDismissOnOutsideClick(containerRef, isOpen, onDismiss) {
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }
    const handlePointerDown = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        onDismiss();
      }
    };
    document.addEventListener('mousedown', handlePointerDown);
    return () => document.removeEventListener('mousedown', handlePointerDown);
  }, [containerRef, isOpen, onDismiss]);
}
